import { set } from 'lodash/fp';

import { AI_CHATBOT_STATUS } from '../../constants/aiChatbot';
import { groupBy } from 'lodash';
import { format } from 'date-fns';
import { addItemToHistoryChat } from '../../utils/aiChatbot';
import { DMY_FORMAT } from '../../constants/dateFormats';

export const SET_STATUS = '[aiChatbot]SET_STATUS';
export const SET_ACTIONS_POPUP_STATUS = '[aiChatbot]SET_ACTIONS_POPUP_STATUS';
export const SET_SEARCH_TEXT = '[aiChatbot]SET_SEARCH_TEXT';
export const SET_LOADING = '[aiChatbot]SET_LOADING';
export const SET_HISTORY = '[aiChatbot]SET_HISTORY';
export const SET_CHATBOT_ANSWER = '[aiChatbot]SET_CHATBOT_ANSWER';

const INITIAL_STATE = {
  status: AI_CHATBOT_STATUS.OFF,
  actionsPopupStatus: AI_CHATBOT_STATUS.OFF,
  searchText: '',
  history: null,
  ui: {
    loading: {
      history: false,
      chatbotAnswer: false,
    },
  },
};

export function aiChatbotReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_STATUS: {
      const oppositeStatus = state.status === AI_CHATBOT_STATUS.OFF ? AI_CHATBOT_STATUS.ON : AI_CHATBOT_STATUS.OFF;

      return {
        ...state,
        status: action?.payload?.status ?? oppositeStatus,
        history: [],
      };
    }

    case SET_ACTIONS_POPUP_STATUS: {
      const oppositeStatus =
        state.actionsPopupStatus === AI_CHATBOT_STATUS.OFF ? AI_CHATBOT_STATUS.ON : AI_CHATBOT_STATUS.OFF;

      return {
        ...state,
        actionsPopupStatus: action?.payload?.actionsPopupStatus ?? oppositeStatus,
      };
    }

    case SET_SEARCH_TEXT: {
      return {
        ...state,
        searchText: action.payload.text,
      };
    }

    case SET_LOADING: {
      const { key, value } = action.payload;

      return set(`ui.loading.${key}`, value, state);
    }

    case SET_CHATBOT_ANSWER: {
      const { chatbotAnswer } = action.payload;
      const existingHistory = state.history;
      addItemToHistoryChat(chatbotAnswer, existingHistory);
      return {
        ...state,
        history: existingHistory,
        ui: set('loading.chatbotAnswer', false, state.ui),
      };
    }

    case SET_HISTORY: {
      const { history } = action.payload;
      let mappedHistory = {};
      if (Array.isArray(history)) {
        mappedHistory = groupBy(history, function (historyItem) {
          return format(new Date(historyItem.createdAt), DMY_FORMAT);
        });
      } else mappedHistory = history;

      return {
        ...state,
        history: mappedHistory,
        ui: set('loading.history', false, state.ui),
        searchText: '',
      };
    }

    default:
      return state;
  }
}
